import {
  buildHandoverDeepLink,
  encodeHandoverProject,
} from "@plaatplan/core";

/**
 * @param {object} project Normalized project.
 */
export function buildWorkshopHandoff(project) {
  const envelope = encodeHandoverProject(project);
  const deepLink = buildHandoverDeepLink(envelope);

  return {
    envelope,
    deepLink,
    payloadLength: envelope.d.length,
    linkLength: deepLink.length,
  };
}
